<template>
    <div
        v-if="policyInfo !== null"
        class="accordion-content"
        data-tab-content
        data-test-policy-section-view-lv-2
    >
        <level-two-buttons :button-info="policyInfo" />
        <level-two-details :policy-details="policyInfo" />
    </div>
</template>

<script>
import LevelTwoButtons from './LevelTwoButtons.vue';
import LevelTwoDetails from './LevelTwoDetails.vue';

export default {
    components: {
        LevelTwoButtons,
        LevelTwoDetails
    },
    props: {
        policyInfo: {
            type: Object,
            default() {
                return null;
            }
        }
    }
};
</script>